<template>
  <div style="height: 100%;">
    <drag-size mode='vertical' :showmain='!uploading' @update='ondead'>
      <template v-slot:main>
        <div v-if="!uploading" style="height: 100%;display: flex;flex-direction: column;">
          <div>
            <!-- <input type="file" ref="upload" accept="*/*" @click="(event)=>{event.target.value = null}" @change='fileChange' style="display: none;"> -->
            <!-- <el-button style="margin-left: 50px;" type="primary" icon="el-icon-upload" @click="$refs['upload'].click()" spId>选择文件</el-button> -->
            <span style="color:red;line-height: 28px;font-weight: bold;">1，请从execl表格把清单粘贴进来（要求第一行为表头，不能有合并单元格）</span>
            <el-button icon="el-icon-error" @click="$emit('errortbn')" style="background-color: orange;color: white;float: right;">关闭</el-button>
          </div>
          <div ref="fa" style="flex:1;overflow: hidden;">
            <div ref="zi" style="position: relative;width: 100%;height: 350px;">
              <div id="luckysheet" style="margin:0px;padding:0px;position:absolute;width:100%;height:100%;left: 0px;top: 0px;z-index: 0;"></div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:athor>
        <div style="height: 100%;display: flex;flex-direction: column;">
          <div style="background-color: #bedafb;">
            <span style="color:red;line-height: 28px;font-weight: bold;">2，以下为匹配结果</span>
            <label style="line-height: 28px;margin: 0 18px;">服务商</label>
            <el-select v-model="spId" filterable clearable placeholder="请选择服务商" class="yellow-input" style="margin-right: 18px;">
              <el-option v-for="(item,i) in branchlist" :key="i" :label="item.branchName" :value="item.branchCode">
              </el-option>
            </el-select>
            <el-button-group>
              <el-button type="primary" icon="el-icon-s-platform" :disabled="!calctable.length || !spId" @click="getcalcFreight">计算费用</el-button>
              <el-button type="primary" :disabled="!calctable.length || !spId" @click="tableEdet = true">匹配完成</el-button>
              <el-button icon="el-icon-upload" :disabled="!calctable.length || !spId" @click="getputStoragescan">上传</el-button>
              <el-button icon="el-icon-error" @click="$emit('errortbn')" style="background-color: orange;color: white;" v-if="uploading">关闭</el-button>
              <span v-if="tableEdet" style="color:red;line-height: 25px;margin-left: 20px;"> | Tab | (tab键)可切换编辑单元格</span>
            </el-button-group>
          </div>
          <div style="flex: 1;overflow: hidden;">
            <vxe-grid border keep-source show-overflow height="auto" auto-resize ref="diaxTable" :row-style="rowstyle" :columns='columns' :data='calctable' :edit-config="{trigger: 'click', mode: 'cell', showIcon: false}" :cell-style="{backgroundColor: tableEdet?'':'lightgray'}" :mouse-config="{selected: true}" :keyboard-config="{isTab: true,isEdit:true,isArrow: true}">
              <template #slots_header="{ $columnIndex }">
                <el-select v-if="!tableEdet" :value="columns[$columnIndex].children[0].title" placeholder="请选择" @change='changelie($event,$columnIndex)'>
                  <el-option v-for="(item,index) in excclhead" :key="index" :label="item.label" :value="item.label">
                  </el-option>
                </el-select>
                <span v-else>{{columns[$columnIndex].children[0].title}}</span>
              </template>
              <template #slots_edit="{row, $columnIndex}">
                <template v-if="tableEdet">
                  <el-select v-if="$columnIndex == 2" filterable v-model="row.quoteCode" placeholder="请选择" @change='changequote($event,row)'>
                    <el-option v-for="(item,index) in crrquotelist" :key="index" :label="item.providerQuoteName" :value="item.providerQuoteCode">
                    </el-option>
                  </el-select>
                  <el-select v-else-if="$columnIndex == 3" v-model="row.destination" filterable default-first-option remote :remote-method="filterCountry" @change='changedestination($event,row)' clearable placeholder="请选择目的地">
                    <el-option :value="country.countryCode" :label="country.nameChinese" v-for="(country,i) in countryOptionsCrror" :key="i">{{country.countryCode}}<el-divider direction="vertical"></el-divider>{{country.nameChinese}}<el-divider direction="vertical"></el-divider>{{country.nameEnglish}}</el-option>
                  </el-select>
                  <el-select v-else-if="$columnIndex == 7" filterable v-model="row.battery" placeholder="请选择">
                    <el-option v-for="(item,index) in [{label:'无电',value:0},{label:'内电',value:1},{label:'外电',value:2},{label:'纯电',value:3}]" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-else-if="$columnIndex == 8" filterable v-model="row.gateDeclared" placeholder="请选择">
                    <el-option v-for="(item,index) in [{label:'不报关',value:0},{label:'报关',value:1}]" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-else-if="$columnIndex == 9" filterable v-model="row.getgoodsType" placeholder="请选择">
                    <el-option v-for="(item,index) in [{label:'文件',value:0},{label:'包裹',value:1},{label:'PAK袋',value:2}]" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <vxe-input v-else type="text" v-model="row[columns[$columnIndex].children[0].field]"></vxe-input>
                </template>
                <template v-else>{{columns[$columnIndex].children[0].formatter?columns[$columnIndex].children[0].formatter({row}):row[columns[$columnIndex].children[0].field]}}</template>
              </template>
              <template #slots_default_wayBillNo="{ row }">
                <el-tooltip class="item" effect="dark" :disabled="!row.wayBillNonNotCheck" content="运单重复" placement="top-start">
                  <div :style="{backgroundColor:row.wayBillNonNotCheck?'red':'transparent'}">{{row.wayBillNo}}</div>
                </el-tooltip>
              </template>
              <template #slots_default_freight="{ row }">
                <el-tooltip class="item" effect="dark" :disabled="!row.calcFreightNotCheck" content="算费失败" placement="top-start">
                  <div :style="{backgroundColor:row.calcFreightNotCheck?'red':'transparent'}">{{row.calcFreightNotCheck?'算费失败':row.freight}}</div>
                </el-tooltip>
              </template>
            </vxe-grid>
          </div>
        </div>
      </template>
    </drag-size>
  </div>
</template>

<script>
import * as string from '@/utils/string'
import { page } from '@/mixins/page'
import LuckyExcel from 'luckyexcel'
export default {
	mixins: [page],
	data() {
		return {
			quotelist: [], // 渠道
			countryOptions: [], // 国家
			countryOptionsCrror: [], // 国家
			tableEdet: false,
			sheetdata: [], // 电子表格数据
			columns: [
				{
					title: '系统：',
					children: [
						{
							type: 'seq',
							title: 'EXCEL表头:',
							width: 90,
						},
					],
				},
				{
					title: '运单号',
					children: [
						{
							field: 'wayBillNo',
							// title: '运单号',
							width: 140,
							slots: { header: 'slots_header', edit: 'slots_edit', default: 'slots_default_wayBillNo' },
							editRender: { enabled: true, autofocus: '.vxe-input--inner' },
						},
					],
				},
				{
					title: '收货渠道',
					children: [
						{
							field: 'quoteCode',
							// title: '收货渠道',
							width: 140,
							reverse: this.getquoteCode,
							formatter: ({ row }) => row['quoteName'],
							slots: { header: 'slots_header', edit: 'slots_edit' },
							editRender: { enabled: true, autofocus: '.el-input__inner' },
						},
					],
				},
				{
					title: '目的地',
					children: [
						{
							field: 'destination',
							// title: '目的地',
							width: 140,
							reverse: this.getdestination,
							formatter: ({ row }) => row['destinationName'],
							slots: { header: 'slots_header', edit: 'slots_edit' },
							editRender: { enabled: true, autofocus: '.el-input__inner' },
						},
					],
				},
				{
					title: '件数',
					children: [
						{
							field: 'pieces',
							// title: '件数',
							width: 140,
							slots: { header: 'slots_header', edit: 'slots_edit' },
							editRender: { enabled: true, autofocus: '.vxe-input--inner' },
						},
					],
				},
				{
					title: '结算重',
					children: [
						{
							field: 'settlementWeight',
							// title: '结算重',
							width: 140,
							reverse: this.getsettlementWeight,
							slots: { header: 'slots_header', edit: 'slots_edit' },
							editRender: { enabled: true, autofocus: '.vxe-input--inner' },
						},
					],
				},
				{
					title: '申报价值',
					children: [
						{
							field: 'valueDeclared',
							// title: '申报价值',
							width: 140,
							reverse: this.getvalueDeclared,
							slots: { header: 'slots_header', edit: 'slots_edit' },
							editRender: { enabled: true, autofocus: '.vxe-input--inner' },
						},
					],
				},
				{
					title: '电池',
					children: [
						{
							field: 'battery',
							// title: '电池',
							width: 140,
							reverse: this.getbattery,
							formatter: ({ row }) => (row['battery'] === 0 ? '无电' : row['battery'] === 1 ? '内电' : row['battery'] === 2 ? '外电' : row['battery'] === 3 ? '纯电' : ''),
							slots: { header: 'slots_header', edit: 'slots_edit' },
							editRender: { enabled: true, autofocus: '.el-input__inner' },
						},
					],
				},
				{
					title: '报关',
					children: [
						{
							field: 'gateDeclared',
							// title: '报关',
							width: 140,
							reverse: this.getgateDeclared,
							formatter: ({ row }) => (row['gateDeclared'] === 0 ? '不报关' : row['gateDeclared'] === 1 ? '报关' : ''),
							slots: { header: 'slots_header', edit: 'slots_edit' },
							editRender: { enabled: true, autofocus: '.el-input__inner' },
						},
					],
				},
				{
					title: '货物类型',
					children: [
						{
							field: 'goodsType',
							// title: '货物类型',
							width: 140,
							reverse: this.getgoodsType,
							formatter: ({ row }) => (row['goodsType'] === 0 ? '文件' : row['goodsType'] === 1 ? '包裹' : row['goodsType'] === 2 ? 'PAK袋' : ''),
							slots: { header: 'slots_header', edit: 'slots_edit' },
							editRender: { enabled: true, autofocus: '.el-input__inner' },
						},
					],
				},
				{
					title: '邮编',
					children: [
						{
							field: 'postCode',
							// title: '邮编',
							width: 140,
							slots: { header: 'slots_header', edit: 'slots_edit' },
							editRender: { enabled: true },
						},
					],
				},
				{
					title: '预报备注',
					children: [
						{
							field: 'remark',
							// title: '预报备注',
							width: 140,
							slots: { header: 'slots_header', edit: 'slots_edit' },
							editRender: { enabled: 'input' },
						},
					],
				},
				{ field: 'freight', title: '运费', width: 140 },
				{ field: 'inFreightConditionAdd', title: '附加费用', width: 140 },
				{ field: 'amount', title: '合计', width: 140 },
				{ field: 'errMsg', title: '问题信息', width: 140 },
				{ field: 'actionDesc', title: '提示信息', width: 140 },
			],
			calctable: [],
			uploading: false,
			saveMatching: {},
			sioption: false,
		}
	},
	computed: {
		// 可选列
		excclhead() {
			if (!this.sheetdata.length) return []
			let excclhead = []
			this.sheetdata[0].forEach((head, headindex) => {
				if (!head || !head.m) return
				excclhead.push({ label: head.m, value: headindex })
			})
			return excclhead
		},
		// 匹配列
		tableList() {
			if (!this.excclhead.length) return []
			this.columns.forEach((columns) => {
				if (!columns || !columns.children || columns.children.length != 1) return
				let conf = columns.children[0]
				if (!conf || !conf.field || !columns.title) return
				this.excclhead.forEach((head) => {
					if (head.label == columns.title) {
						conf.title = columns.title
					}
					let title = this.saveMatching[columns.title]
					if (title && title == head.label) {
						conf.title = title
					}
				})
				if (!conf || !conf.field || !conf.title) return
				this.excclhead.forEach((head) => {
					if (head.label == conf.title) {
						conf.title = conf.title
						conf.matchingValue = head.value
					}
				})
			})
			// 匹配数据
			if (!this.spId || this.sheetdata.length < 2) return []
			let tableList = []
			this.sheetdata.slice(1).forEach((element) => {
				let row = {}
				this.columns.forEach((columns) => {
					if (!columns || !columns.children || columns.children.length != 1) return
					let conf = columns.children[0]
					if (!conf || !conf.field || !conf.title || conf.matchingValue == undefined || !element[conf.matchingValue] || !element[conf.matchingValue].m) return
					if (conf.reverse) {
						conf.reverse(element[conf.matchingValue].m, row)
					} else {
						row[conf.field] = element[conf.matchingValue].m
					}
				})
				if (JSON.stringify(row) != '{}') tableList.push(row)
			})
			return tableList
		},
		crrquotelist() {
			if (!this.spId) return []
			return [...this.quotelist.filter((ele) => ele.providerCode == this.spId)]
		},
	},
	watch: {
		tableList(val) {
			this.calctable = val
		},
		tableEdet() {
			let data = luckysheet.getAllSheets()
			this.create(data, this.hander, false)
		},
	},
	mounted() {
		this.getSave()
		this.getquotelist()
		this.getCountrylist()
		this.init()
	},
	methods: {
		// 所有渠道
		async getquotelist() {
			this.quotelist = await this.$api.getquotelist()
		},
		// 默认过滤
		async getCountrylist() {
			this.countryOptions = await this.$api.countrylist()
			this.countryOptionsCrror = this.countryOptions
		},
		// 国家过滤
		async filterCountry(country) {
			if (country) {
				let countryOptionsCrror = this.countryOptions.filter((options) => {
					// 国家二字码大写，中文,首字母大写,拼音小写对比
					return options.countryCode.indexOf(country.toUpperCase()) != -1 || options.nameChinese.indexOf(country) != -1 || options.nameEnglish.toLowerCase().indexOf(country.toLowerCase()) != -1 || options.firstPinYin.indexOf(country.toUpperCase()) != -1 || string.getPinYinFirstCharacter(options.nameChinese.toLowerCase()).indexOf(country.toLowerCase()) != -1
				})
				countryOptionsCrror.sort((a, b) => {
					let crr_a = a.countryCode == country.toUpperCase() || a.nameChinese == country || a.nameEnglish.toLowerCase() == country.toLowerCase() || a.firstPinYin == country.toUpperCase() || string.getPinYinFirstCharacter(a.nameChinese.toLowerCase()) == country.toLowerCase()
					let crr_b = b.countryCode == country.toUpperCase() || b.nameChinese == country || b.nameEnglish.toLowerCase() == country.toLowerCase() || b.firstPinYin == country.toUpperCase() || string.getPinYinFirstCharacter(b.nameChinese.toLowerCase()) == country.toLowerCase()
					if (crr_a && !crr_b) return -1
					return 1
				})
				this.countryOptionsCrror = countryOptionsCrror
			} else {
				this.countryOptionsCrror = this.countryOptions
			}
		},
		// 读取排序
		getSave() {
			let COLUMN_MATCHING = localStorage.getItem('COLUMN_MATCHING') || '{}'
			let crr_obj = JSON.parse(COLUMN_MATCHING)
			this.saveMatching = crr_obj
		},
		// 读取排序
		setSave(name, val) {
			this.saveMatching[name] = val
			localStorage.setItem('COLUMN_MATCHING', JSON.stringify(this.saveMatching))
		},
		// 初始化电子表格
		init() {
			let data = [
				{
					name: '工作表', //工作表名称
					column: 26, //列数
					row: 50, //行数
				},
			]
			this.create(data, this.hander, true)
		},
		// 修改电子表格
		hander() {
			let neet = false
			let data = luckysheet.getAllSheets()
			data.forEach((sheel) => {
				sheel.data.forEach((one) => {
					one.forEach((tow, y) => {
						if (!tow) {
							one[y] = { ct: { fa: '@', t: 's' }, v: null, m: '' }
							neet = true
						}
					})
				})
				// element.celldata.forEach((ele, index) => {
				// 	if (!ele) {
				// 		element.celldata[index] = { ct: { fa: '@', t: 's' }, v: null, m: '' }
				// 		neet = true
				// 	}
				// 	// if (ele && ele.v && ele.v.ct && ele.v.ct.fa && ele.v.ct.fa != '@') {
				// 	// 	neet = true
				// 	// 	ele.v.ct.fa = '@'
				// 	// }else{
				// 	// }
				// })
			})
			if (neet) {
				this.create(data, this.hander, true)
			} else {
				this.sheetdata = luckysheet.getSheetData(0)
			}
		},
		ondead() {
			this.$refs['zi'].style.height = this.$refs['fa'].clientHeight - 28 + 'px'
			this.$nextTick(() => {
				let data = luckysheet.getAllSheets()
				this.create(data, this.hander, true)
			})
		},
		// 创建文档表格
		create(data, hander, allowEdit) {
			luckysheet.create({
				container: 'luckysheet', //luckysheet为容器id
				lang: 'zh', // 设定表格语言
				showinfobar: false, //是否显示顶部信息栏
				allowCopy: true, //是否可复制
				showsheetbar: false, // 是否显示底部sheet页按钮
				allowEdit, // 是否允许前台编辑
				defaultColWidth: 150,
				defaultRowHeight: 20,
				data,
				hook: {
					workbookCreateAfter: () => {
						typeof hander === 'function' && hander()
					},
					updated: () => {
						typeof hander === 'function' && hander()
					},
					// cellUpdated: (r,c,o,n,i) => {
					// 	// typeof hander === 'function' && hander()
					// },
					// rangePasteAfter: () => {
					// 	// typeof hander === 'function' && hander()
					// },
				},
			})
		},
		// 导入文件
		async fileChange() {
			let _this = this
			let file = this.$refs['upload'].files[0]
			if (!this.$refs['upload'].files[0].size) return
			if (file.type.indexOf('sheet') >= 0) {
				LuckyExcel.transformExcelToLucky(file, (exportJson) => {
					_this.create(exportJson.sheets, _this.hander, true)
				})
			}
		},
		getquoteCode(val, row) {
			let crr = this.crrquotelist.find((item) => {
				let quoteName = item.providerQuoteName.substr(item.providerQuoteName.lastIndexOf('-') + 1)
				return val.indexOf(quoteName) > -1
			})
			if (crr) {
				row.quoteCode = crr.providerQuoteCode
				row.quoteName = crr.providerQuoteName
			}
		},
		getdestination(val, row) {
			let crr = this.countryOptions.find((item) => item.nameChinese == val)
			if (crr) {
				row.destination = crr.countryCode
				row.destinationName = crr.nameChinese
			}
		},
		getsettlementWeight(val, row) {
			row.settlementWeight = val.indexOf('￥') > -1 ? (isNaN(val.replace('￥', '')) ? '' : Number(val.replace('￥', ''))) : isNaN(val) ? '' : Number(val)
		},
		getvalueDeclared(val, row) {
			row.valueDeclared = val.indexOf('￥') > -1 ? (isNaN(val.replace('￥', '')) ? '' : Number(val.replace('￥', ''))) : isNaN(val) ? '' : Number(val)
		},
		getbattery(val, row) {
			row.battery = val === '无电' ? 0 : val === '内电' ? 1 : val === '外电' ? 2 : val === '纯电' ? 3 : 0
		},
		getgateDeclared(val, row) {
			row.gateDeclared = val === '不报关' ? 0 : val === '报关' ? 1 : 0
		},
		getgoodsType(val, row) {
			row.goodsType = val === '文件' ? 0 : val === '包裹' ? 1 : val === 'PAK袋' ? 2 : 1
		},
		async getcalcFreight() {
			let tableList = [...this.tableList]
			await Promise.all(
				tableList.map(async (element) => {
					element.freight = 0
					element.freightAdd = 0
					element.remoted = false
					if (!element.branchCode) return
					if (!element.quoteCode) return
					if (!element.destination) return
					if (!element.pieces) return
					if (!element.settlementWeight) return
					// 是否偏远
					if (element.postCode && element.cityName) {
						// 查询偏远
						let crrquote = this.crrquotelist.find((crr) => crr.providerQuoteCode == element.quoteCode)
						let remotearea = await this.$api.remoteareasearch({ bizType: crrquote.bizType, countryCode: element.destination, startCode: element.postCode, endCode: element.postCode }) // 偏远
						if (remotearea && remotearea.list && remotearea.list.length) {
							element.remoted = true
						}
					}
					let calcFreight = await this.$api.calcFreight(this.spId, element)
					element.freight = calcFreight.scan.freight
					element.freightAdd = calcFreight.scan.freightConditionAdd
					if (!calcFreight.freightCalcResult) return
					if (calcFreight.freightCalcResult.errCode) {
						// 先取出总体的错误
						switch (calcFreight.freightCalcResult.errCode) {
							case 10:
								element.addFeeObjListval = '【渠道停用;】'
								break
							case 9:
								element.addFeeObjListval = '【此目的地无价格;】'
								break
							case 8:
								element.addFeeObjListval = '【' + element.settlementWeight + 'KG无价格;】'
								break
							case 3:
								element.addFeeObjListval = '【' + calcFreight.freightCalcResult.extraInfo.toString(';') + '】'
								break
							default:
								element.addFeeObjListval = '【无价格;】'
								break
						}
					} else {
						// 加收项错误：addFeeObjList为问题信息， prePortIssues=1&&conditionMatched=true满足问题
						element.addFeeObjListval = calcFreight.freightCalcResult.addFeeObjList.reduce((val, crr) => {
							if (crr.prePortIssues == 1 && crr.conditionMatched == true) {
								val += '[' + crr.ruleRemark + crr.actionDesc + ']'
							}
							return val
						}, '')
					}
					if (this.form.remoted) {
						element.addFeeObjListval += '【偏远！】'
					}
					element.warning = element.addFeeObjListval // 问题
					// 偏远+尺寸备注+非包裹时显示件数
					element = { ...element }
					// 提示
					if (!calcFreight.freightCalcResult.addFeeObjList) return
					// 提示信息：feeType=5为提示信息,conditionMatched==true满足提示
					element.tipsListval = calcFreight.freightCalcResult.addFeeObjList.reduce((val, crr) => {
						if (crr.conditionMatched == true && crr.feeType == 5) {
							val += crr.ruleRemark + crr.actionDesc
						}
						return val
					}, '')
					element.hintMessage = element.tipsListval // 提示
					element = { ...element }
				})
			)
			this.calctable = tableList
		},
		async getputStoragescan() {
			let crrlist = []
			let tableList = [...this.calctable]
			let list = []
			let flog = false
			let cf = []
			tableList.map((element) => {
				if (list.indexOf(element.wayBillNo) > -1) {
					flog = true
					cf.push(element.wayBillNo)
					element.wayBillNonNotCheck = true // 运单重复
				} else {
					list.push(element.wayBillNo)
				}
			})
			if (flog) {
				return this.$message.warning(cf.toString() + '重复上传,请检查')
			}
			this.uploading = true
			await Promise.all(
				tableList.map(async (element) => {
					let obj = {
						branchCode: '',
						wayBillNo: '',
						quoteCode: '',
						destination: '',
						pieces: '',
						settlementWeight: '',
						postCode: '',
						cityName: '',
						valueDeclared: '',
						battery: 1,
						goodsType: 1,
						gateDeclared: 0,
						remark: '',
					}
					element = { ...obj, ...element }
					let crr = false
					if (element.quoteCode && element.destination) {
						let res = await this.$api.putStoragecheck(element.wayBillNo)
						if (res) {
							element.wayBillId = res.wayBillId
						}
						let calcFreight = await this.$api.putStoragescan(this.spId, element)
						if (calcFreight) {
							crr = true
						}
					}
					if (!crr) {
						crrlist.push(element)
					}
				})
			)
			this.calctable = crrlist
			if (this.calctable.length) this.$message.warning('上传失败，请检查')
			if (!this.calctable.length) {
				this.$emit('errortbn')
				this.$message.warning('上传成功')
			}
		},
		changelie(val, columnIndex) {
			this.columns[columnIndex].children[0].title = val
			// 刷新
			this.$refs['diaxTable'].refreshColumn()
			this.hander()
			// 存储 表格列:匹配列
			this.setSave(this.columns[columnIndex].title, val)
		},
		changequote(val, row) {
			let crr = this.crrquotelist.find((item) => {
				return item.providerQuoteCode == val
			})
			if (crr) {
				row.quoteCode = crr.providerQuoteCode
				row.quoteName = crr.providerQuoteName
			}
		},
		changedestination(val, row) {
			let crr = this.countryOptions.find((item) => item.countryCode == val)
			if (crr) {
				row.destination = crr.countryCode
				row.destinationName = crr.nameChinese
			}
		},
		rowstyle({ row }) {
			if (row.calcFreightNotCheck) {
				return {
					color: 'red',
				}
			}
		},
	},
}
</script>

<style>
.main-vertical {
	height: 500px;
}
</style>